import * as actions from './slice'

export const getBookmarked = {
  onStart: {
    action: actions.setLoading,
    redux: true
  },
  eventName: 'bookmarksBatchCheckBookmarked',
  onSuccess: [{ action: actions.setBookmarked, redux: true }],
  onError: [
    { action: actions.setLoadingOff, redux: true }
  ]
}
